import styled from 'styled-components';
import useReportDataContext from '../../hooks/useReportDataContext';
import LoadingAnimation from '../../../../components/loadingAnimation';

const ReportLoadingFallback = ({ children }: { children: React.ReactNode }) => {
  const { reportTitle, reportConfigs } = useReportDataContext();
  if (reportConfigs.isLoading && !reportTitle) {
    return (
      <Wrapper>
        <div className="loading-animation">
          <LoadingAnimation />
          <div className="loading-text">Loading...</div>
        </div>
      </Wrapper>
    );
  }
  return <>{children}</>;
};

export default ReportLoadingFallback;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .loading-animation {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.body};
    backdrop-filter: blur(2px);
    z-index: 2;
    border-radius: 8px;
    flex-direction: column;
  }
  .loading-text {
    font-size: 14px;
    color: #91a1ac;
    font-weight: 500;
  }
`;
